import React from 'react'

const CatalogQuestion = () => {

  const onClickQuestion = (index) => {
    let answer = document.getElementById("answer" + index);
    let arrow = document.getElementById("arrow" + index);
    if (answer.style.display == "none") {
      answer.style.display = "block";
      arrow.className = "catalogQuestionQIconArrowClose"
    } else if (answer.style.display == "block") {
      answer.style.display = "none"
      arrow.className = "catalogQuestionQIconArrow"
    }
  }

  return (
    <div>
      <div className="catalogQuestionWrap">
        <div className="catalogQuestion" onClick={() => onClickQuestion(1)}>
          <div className="catalogQuestionQWrap">
            <p className="catalogQuestionQIcon" >Q</p>
            <p className="catalogQuestionQText">誰がRTCCサービスを利用できますか？</p>
            <div id="arrow1" className="catalogQuestionQIconArrow"></div>
          </div>
        </div>
        <div id="answer1" className="catalogQuestionAWrap" style={{ display: "none" }}>
          <p className="catalogQuestionAIcon" >A</p>
          <p className="catalogQuestionAText">RTCCサービスの付帯している会員権をお持ちの会員様とそのゲスト（家族、友人、従業員等）です。<br />ただし、会員様からのご予約となります。<br />
            ※RTTGポイントクラブへのご登録（会員権ひも付け登録を含む）が必要となります。<br />会員権ひも付け登録の追加方法はこちらをご参照ください：<a href='https://www.resorttrust.co.jp/point/linking/' target="_blank" rel="noopener noreferrer">https://www.resorttrust.co.jp/point/linking/</a></p>
        </div>
      </div>
      <div className="catalogQuestionWrap">
        <div className="catalogQuestion" onClick={() => onClickQuestion(2)}>
          <div className="catalogQuestionQWrap">
            <p className="catalogQuestionQIcon" >Q</p>
            <p className="catalogQuestionQText">変更・取消・返金について</p>
            <div id="arrow2" className="catalogQuestionQIconArrow"></div>
          </div>
        </div>
        <div id="answer2" className="catalogQuestionAWrap" style={{ display: "none" }}>
          <p className="catalogQuestionAIcon" >A</p>
          <p className="catalogQuestionAText">■変更について<br />
            予約後の変更（宿泊開始日・ホテル・お部屋タイプ・宿泊日数・ご参加者・人数など）は出来ません。<br />
            変更する場合は、ご予約済みホテルを取り消し後、新規予約にてお取り直しとなります。<br />
            ※宿泊開始日の14日前以降の変更は、新規予約は出来ませんのでRTCC事務局までお問合せ下さい。<br />
            &nbsp;&nbsp;減員、減泊についても取消料の対象となります。<br />
            <br />
            ■取消料について<br />
            &nbsp;&nbsp;◆RTCCハワイ（海外募集型企画旅行）ｰ　宿泊日の14日前：　旅行代金の20％　2日前から当日：50％　　無連絡：100％<br />
            &nbsp;&nbsp;&nbsp;&nbsp;※詳しくは旅行条件書でご確認下さい。<br />
            &nbsp;&nbsp;◆RTCC宿泊（国内・海外手配旅行）-　宿泊する施設によって異なります。<br />
            &nbsp;&nbsp;&nbsp;&nbsp;予約時の「プランの詳細」に表示される取消料をご確認の上ご予約下さい。<br />
            <br />
            ■予約後の払い戻しについて<br />
            &nbsp;&nbsp;◆クレジットカード払いの場合：<br />
            &nbsp;&nbsp;&nbsp;&nbsp;・宿泊日の15日前まで ― 全額、提携会社のカード会員規約に従い払い戻します。<br />
            &nbsp;&nbsp;&nbsp;&nbsp;・宿泊日の14日前以降 ― 提携会社のカード会員規約に従って、旅行代金全額を払い戻した後、所定の取消料を請求します。（取消料分のクレジット利用処理）<br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;※国内ホテルで取消料が発生しない場合は全額、提携会社のカード会員規約に従い払い戻します。<br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;※取消料が発生する場合は、取消の翌営業日以降の処理となります。<br />
            &nbsp;&nbsp;◆お振込みでのお支払いの場合：<br />
            &nbsp;&nbsp;&nbsp;&nbsp;・宿泊日の15日前まで ― 全額、お客様ご指定の銀行口座に払い戻します。<br />
            &nbsp;&nbsp;&nbsp;&nbsp;・宿泊日の14日前以降 ― 所定の取消料を差し引いた金額を、お客様ご指定の銀行口座に払い戻します。<br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;※国内ホテルで取消料が発生しない場合は全額、銀行振り込みにて払い戻します。</p>
        </div>
      </div>
      <div className="catalogQuestionWrap">
        <div className="catalogQuestion" onClick={() => onClickQuestion(3)}>
          <div className="catalogQuestionQWrap">
            <p className="catalogQuestionQIcon" >Q</p>
            <p className="catalogQuestionQText">宿泊日の14日前以降の変更（増員・減員・減泊）について</p>
            <div id="arrow3" className="catalogQuestionQIconArrow"></div>
          </div>
        </div>
        <div id="answer3" className="catalogQuestionAWrap" style={{ display: "none" }}>
          <p className="catalogQuestionAIcon" >A</p>
          <p className="catalogQuestionAText">宿泊日の14日前以降の変更については、上記記載の取消料の対象となります。　RTCC事務局までお電話でご相談下さい。<br />
            変更に伴い、追加料金が発生する場合のお支払い方法は、全て銀行振り込みとなります。<br />（振込手数料は利用者様のご負担となります）</p>
        </div>
      </div>
      <div className="catalogQuestionWrap">
        <div className="catalogQuestion" onClick={() => onClickQuestion(4)}>
          <div className="catalogQuestionQWrap">
            <p className="catalogQuestionQIcon" >Q</p>
            <p className="catalogQuestionQText">予約期間はいつからいつまでですか？</p>
            <div id="arrow4" className="catalogQuestionQIconArrow"></div>
          </div>
        </div>
        <div id="answer4" className="catalogQuestionAWrap" style={{ display: "none" }}>
          <p className="catalogQuestionAIcon" >A</p>
          <p className="catalogQuestionAText">15日から最長で350日先までの予約が可能です。<br />
            ※宿泊日・宿泊数の検索条件及び空室状況によっては、検索結果に表示されない場合があります。</p>
        </div>
      </div>
      <div className="catalogQuestionWrap">
        <div className="catalogQuestion" onClick={() => onClickQuestion(5)}>
          <div className="catalogQuestionQWrap">
            <p className="catalogQuestionQIcon" >Q</p>
            <p className="catalogQuestionQText">RTCCハワイ（海外募集型企画旅行）の催行の基準は何ですか？</p>
            <div id="arrow5" className="catalogQuestionQIconArrow"></div>
          </div>
        </div>
        <div id="answer5" className="catalogQuestionAWrap" style={{ display: "none" }}>
          <p className="catalogQuestionAIcon" >A</p>
          <p className="catalogQuestionAText">従来どおり外務省の要請に従い催行判断をいたします。「外務省感染症危険情報」がレベル2以上(不要不急の渡航は止めてください・渡航中止勧告）である場合は、催行中止とさせていただきますことを予めご了承ください。<br />
            尚、催行中止の場合は、ご宿泊初日の約30日前を目安にご連絡を差し上げます。<br />
            <br />
            感染症危険情報については、外務省の海外安全ホームページでご確認ください。　<a href='https://www.anzen.mofa.go.jp/' target="_blank" rel="noopener noreferrer">https://www.anzen.mofa.go.jp/</a>
          </p>
        </div>
      </div>
      <div className="catalogQuestionWrap">
        <div className="catalogQuestion" onClick={() => onClickQuestion(6)}>
          <div className="catalogQuestionQWrap">
            <p className="catalogQuestionQIcon" >Q</p>
            <p className="catalogQuestionQText">ベッド台数、眺望指定等指定出来ないの？　</p>
            <div id="arrow6" className="catalogQuestionQIconArrow"></div>
          </div>
        </div>
        <div id="answer6" className="catalogQuestionAWrap" style={{ display: "none" }}>
          <p className="catalogQuestionAIcon" >A</p>
          <p className="catalogQuestionAText">プラン名にベッド台数、眺望条件の記載のないプランに関しては事前指定は出来ません。</p>
        </div>
      </div>
      <div className="catalogQuestionWrap">
        <div className="catalogQuestion" onClick={() => onClickQuestion(7)}>
          <div className="catalogQuestionQWrap">
            <p className="catalogQuestionQIcon" >Q</p>
            <p className="catalogQuestionQText">添寝をご希望のお客様について</p>
            <div id="arrow7" className="catalogQuestionQIconArrow"></div>
          </div>
        </div>
        <div id="answer7" className="catalogQuestionAWrap" style={{ display: "none" }}>
          <p className="catalogQuestionAIcon" >A</p>
          <p className="catalogQuestionAText">定員数は、ベッドをご利用の大人又は子供に応じた人数で表示しております。<br />※必ずしも利用人数と同数のベッドが用意されるとは限りません。<br />
            <br />
            お手数ですが、添い寝のお子様に関しては、RTCC事務局へお電話にてご相談下さい。</p>
        </div>
      </div>
      <div className="catalogQuestionWrap">
        <div className="catalogQuestion" onClick={() => onClickQuestion(8)}>
          <div className="catalogQuestionQWrap">
            <p className="catalogQuestionQIcon" >Q</p>
            <p className="catalogQuestionQText">RTCCハワイ（海外募集型企画旅行）でアーリーチェックイン、レイトチェックアウトを希望する場合どうやって予約したらいい？</p>
            <div id="arrow8" className="catalogQuestionQIconArrow"></div>
          </div>
        </div>
        <div id="answer8" className="catalogQuestionAWrap" style={{ display: "none" }}>
          <p className="catalogQuestionAIcon" >A</p>
          <p className="catalogQuestionAText">プラン内容に特段の記載がない場合、チェックイン時間は15時、チェックアウト時間は10時となります。<br />
            アーリーチェックインであればご宿泊希望日の一日前より、レイトチェックアウトであれば1日後までの日程で予約してください。予約完了後、お手数ですが、RTCC事務局までその旨お伝え下さい。　※該当日の1日分の追加代金が発生します。</p>
        </div>
      </div>
      <div className="catalogQuestionWrap">
        <div className="catalogQuestion" onClick={() => onClickQuestion(9)}>
          <div className="catalogQuestionQWrap">
            <p className="catalogQuestionQIcon" >Q</p>
            <p className="catalogQuestionQText">RTTGアプリや予約サイトを使っていません。お電話での空室照会、電話予約は可能でしょうか？</p>
            <div id="arrow9" className="catalogQuestionQIconArrow"></div>
          </div>
        </div>
        <div id="answer9" className="catalogQuestionAWrap" style={{ display: "none" }}>
          <p className="catalogQuestionAIcon" >A</p>
          <p className="catalogQuestionAText">お電話でも承っております。ご希望の商品がございましたら会員様の会員権情報、ご希望の日程等RTCC事務局スタッフまでお知らせください。<br />
            &nbsp;&nbsp;※ネット予約に比べ、予約完了までにお時間を要する場合がございます。<br />
            &nbsp;&nbsp;※電話予約の場合、お支払いは銀行振込みのみとなります。（振込手数料は利用者様のご負担となります）<br />
            <br />
            リゾートトラスト㈱ RTCC事務局 TEL 052-307-3030 までお問い合わせください。<br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            営業時間　平日10:00～17:00（休業日：土曜、日曜、祝日、弊社が定める休業日）</p>
        </div>
      </div>
      <div className="catalogQuestionWrap">
        <div className="catalogQuestion" onClick={() => onClickQuestion(10)}>
          <div className="catalogQuestionQWrap">
            <p className="catalogQuestionQIcon" >Q</p>
            <p className="catalogQuestionQText">RTTGポイントを利用したいですが可能でしょうか？</p>
            <div id="arrow10" className="catalogQuestionQIconArrow"></div>
          </div>
        </div>
        <div id="answer10" className="catalogQuestionAWrap" style={{ display: "none" }}>
          <p className="catalogQuestionAIcon" >A</p>
          <p className="catalogQuestionAText">大変申し訳ございませんが、現在のところ、ご利用いただけません。</p>
        </div>
      </div>
    </div>
  );
}

export default CatalogQuestion;